﻿import administrationEnUS from './enUS/administration.json' with { type: 'json' };
import boatEnUS from './enUS/boat.json' with { type: 'json' };
import campaignEnUS from './enUS/campaign.json' with { type: 'json' };
import chatbotEnUS from './enUS/chatbot.json' with { type: 'json' };
import commissioningEnUS from './enUS/commissioning.json' with { type: 'json' };
import commonEnUS from './enUS/common.json' with { type: 'json' };
import commonButtonEnUS from './enUS/commonButton.json' with { type: 'json' };
import commonStatusEnUS from './enUS/commonStatus.json' with { type: 'json' };
import commonUnitEnUS from './enUS/commonUnit.json' with { type: 'json' };
import commonWizardEnUS from './enUS/commonWizard.json' with { type: 'json' };
import componentEnUS from './enUS/component.json' with { type: 'json' };
import componentInformationPlateEnUS from './enUS/componentInformationPlate.json' with { type: 'json' };
import connectedUnitsEnUS from './enUS/connectedUnits.json' with { type: 'json' };
import customerEnUS from './enUS/customer.json' with { type: 'json' };
import deploymentAlertEnUS from './enUS/deploymentAlert.json' with { type: 'json' };
import drivelineviewEnUS from './enUS/drivelineview.json' with { type: 'json' };
import errorEnUS from './enUS/error.json' with { type: 'json' };
import eventLogEnUS from './enUS/eventLog.json' with { type: 'json' };
import fileUploadEnUS from './enUS/fileUpload.json' with { type: 'json' };
import healthCheckEnUS from './enUS/healthCheck.json' with { type: 'json' };
import homeEnUS from './enUS/home.json' with { type: 'json' };
import languageEnUS from './enUS/language.json' with { type: 'json' };
import layoutEnUS from './enUS/layout.json' with { type: 'json' };
import maintenancePlannerEnUS from './enUS/maintenancePlanner.json' with { type: 'json' };
import menuEnUS from './enUS/menu.json' with { type: 'json' };
import orderInfoEnUS from './enUS/orderInfo.json' with { type: 'json' };
import productInOperationEnUS from './enUS/productInOperation.json' with { type: 'json' };
import productIndividualEnUS from './enUS/productIndividual.json' with { type: 'json' };
import productPopulationEnUS from './enUS/productPopulation.json' with { type: 'json' };
import productTypeEnUS from './enUS/productType.json' with { type: 'json' };
import qaAccessEnUS from './enUS/qaAccess.json' with { type: 'json' };
import releaseNotesEnUS from './enUS/releaseNotes.json' with { type: 'json' };
import relocateToEnUS from './enUS/relocateTo.json' with { type: 'json' };
import searchProductEnUS from './enUS/searchProduct.json' with { type: 'json' };
import serviceContractsEnUS from './enUS/serviceContracts.json' with { type: 'json' };
import serviceProtocolEnUS from './enUS/serviceProtocol.json' with { type: 'json' };
import unitCreationEnUS from './enUS/unitCreation.json' with { type: 'json' };
import unitEditEnUS from './enUS/unitEdit.json' with { type: 'json' };
import unitOverviewEnUS from './enUS/unitOverview.json' with { type: 'json' };
import warrantyEnUS from './enUS/warranty.json' with { type: 'json' };

export const resources = {
	enUS: {
		administration: administrationEnUS,
		boat: boatEnUS,
		campaign: campaignEnUS,
		chatbot: chatbotEnUS,
		commissioning: commissioningEnUS,
		common: commonEnUS,
		commonButton: commonButtonEnUS,
		commonStatus: commonStatusEnUS,
		commonUnit: commonUnitEnUS,
		commonWizard: commonWizardEnUS,
		component: componentEnUS,
		componentInformationPlate: componentInformationPlateEnUS,
		connectedUnits: connectedUnitsEnUS,
		customer: customerEnUS,
		deploymentAlert: deploymentAlertEnUS,
		drivelineview: drivelineviewEnUS,
		error: errorEnUS,
		eventLog: eventLogEnUS,
		fileUpload: fileUploadEnUS,
		home: homeEnUS,
		language: languageEnUS,
		layout: layoutEnUS,
		maintenancePlanner: maintenancePlannerEnUS,
		menu: menuEnUS,
		orderInfo: orderInfoEnUS,
		productIndividual: productIndividualEnUS,
		productInOperation: productInOperationEnUS,
		productPopulation: productPopulationEnUS,
		productType: productTypeEnUS,
		releaseNotes: releaseNotesEnUS,
		relocateTo: relocateToEnUS,
		searchProduct: searchProductEnUS,
		serviceContracts: serviceContractsEnUS,
		serviceProtocol: serviceProtocolEnUS,
		unitCreation: unitCreationEnUS,
		unitEdit: unitEditEnUS,
		unitOverview: unitOverviewEnUS,
		warranty: warrantyEnUS,
		healthCheck: healthCheckEnUS,
		qaAccess: qaAccessEnUS,
	},
} as const;

export const namespaces = [
	'administration',
	'boat',
	'campaign',
	'chatbot',
	'commissioning',
	'common',
	'commonButton',
	'commonStatus',
	'commonUnit',
	'commonWizard',
	'component',
	'componentInformationPlate',
	'connectedUnits',
	'customer',
	'deploymentAlert',
	'drivelineview',
	'error',
	'eventLog',
	'fileUpload',
	'home',
	'language',
	'layout',
	'maintenancePlanner',
	'menu',
	'orderInfo',
	'productIndividual',
	'productInOperation',
	'productPopulation',
	'productType',
	'releaseNotes',
	'relocateTo',
	'searchProduct',
	'serviceContracts',
	'serviceProtocol',
	'unitCreation',
	'unitEdit',
	'unitOverview',
	'warranty',
	'healthCheck',
	'qaAccess',
];
